import { ComplaintsService } from "@/services/complaints"
import { createContainer } from "@/util/context"
import { useState } from "react"

const Global = () => {
    const [eligibleAmount, setEligibleAmount] = useState<any>({})
    const [adjustmentEligibleAmount, setAdjustmentEligibleAmount] = useState<any>({})


    const enableChargebackButton = async (id: any, type: any) => {
        try {
            const data = await ComplaintsService.enableChargebackButton(id, type)
            const dat = data.data
            setEligibleAmount(dat)

        } catch (error) {
            console.log(error)
        }
    }
     const adjustmentEnableChargebackButton = async (id: any, type: any) => {
        try {
            const data = await ComplaintsService.adjustmentEnableChargebackButton(id, type)
            const dat = data.data
            setAdjustmentEligibleAmount(dat)

        } catch (error) {
            console.log(error)
        }
    }
    return {
        eligibleAmount, setEligibleAmount, enableChargebackButton,
        adjustmentEligibleAmount, setAdjustmentEligibleAmount,adjustmentEnableChargebackButton
    }
}
export const GlobalStore = createContainer(Global)
